import React, { useState, useRef } from "react";
// import Table from "react-bootstrap/Table";
import "./../../Assets/css/print.css";
import { formatDateTime, formatDateTimeWithSeconds } from "../../Utils/dateFormat";

const CheckOutModel = ({ room, check_out_detail, session }) => {
  return (
    <>
      {" "}
      <div className="d-flex flex-column p-3">
        <h4>THE FRED</h4>

        <div className="border p-3">
          <h5 className="headDesigne p-1">Customer Detail</h5>
          <br />
          <h6>Room Name: {session?.room?.name}</h6>
          <h6>Customer Name: {session?.customer?.name}</h6>
          <h6>Mobile Number: {session?.customer?.phone_number}</h6>
          <h6>Check in Date: {formatDateTime(session?.check_in)}</h6>
          <h6>Check out Date: {formatDateTime(session?.check_out)}</h6>
        </div>

        <table className="table table-hover table-bordered  mt-4 print-table">
          <thead className="headDesigne">
            <tr>
              <th>Sr</th>
              <th>Item</th>
              <th>Qty</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {check_out_detail &&
              check_out_detail.map((item, i) => (
                <tr key={item?.id}>
                  <td>{i + 1}</td>
                  <td>{item?.menu?.name}</td>
                  <td>{item?.qty}</td>
                  <td>{item?.status?.name}</td>
                  <td>{formatDateTimeWithSeconds(item?.created_at)}</td>
                </tr>
              ))}
          </tbody>
        </table>
        {check_out_detail.length === 0 && (
          <p className="text-danger text-center">No Order Found</p>
        )}
        {check_out_detail.click === 1 && <p className="disabled"></p>}
      </div>
    </>
  );
};

export default CheckOutModel;

// import Table from "react-bootstrap/Table";

export const ViewReport = ({ reportData }) => {
  return (
    <>
      {" "}
      <div className="d-flex flex-column p-3">
        <h4>The FRED</h4>

        <div className="border p-3">
          <h5 className="headDesigne p-1">Customer Detail</h5>
          <br />
          <h6>Room Name: {reportData[0]?.room?.name}</h6>
          <h6>Customer Name: {reportData[0]?.customer?.name}</h6>
          <h6>Mobile Number: {reportData[0]?.customer?.phone_number}</h6>
          <h6>Check in Date: {formatDateTime(reportData[0]?.check_in)}</h6>
          <h6>Check out Date: {formatDateTime(reportData[0]?.check_out)}</h6>
        </div>

        <table className="table table-hover table-bordered  mt-4">
          <thead className="headDesigne">
            <tr>
              <th>Sr</th>
              <th>Item</th>
              <th>Qty</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {(reportData[0]?.orders ?? []).map((item, i) => (
              <tr key={item?.id}>
                <td>{i + 1}</td>
                <td>{item?.menu?.name}</td>
                <td>{item?.qty}</td>
                <td>{item?.status?.name}</td>
                <td>{formatDateTimeWithSeconds(item?.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {(reportData[0]?.orders ?? []).length === 0 && (
          <p className="text-danger text-center">No Order Found</p>
        )}
      </div>
    </>
  );
};
